import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import useOfSold from "../../../../../assets/design-revamp-company/company-detail-headers/use-of-sold-icon.svg";
import { useTranslation } from "react-i18next";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import { getCompUseSoldTotal } from "../../../../../apis/Business/CompanyUseSoldTotalApi";
import { Trans } from "react-i18next";

const UseOfSoldIcon = () => (
  <img src={useOfSold} alt="Use of Sold Icon" width={76} height={76} />
);

const UseOfSoldHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjUseSold, setTotalObjUseSold] = useState([]);
  const [systemBoundaryUseSold, setSystemBoundaryUseSold] = useState("");
  useEffect(() => {
    getCompUseSoldTotal({
      businessId: businessId,
      setTotalObj: setTotalObjUseSold,
      setSystemBoundary: setSystemBoundaryUseSold,
    });
  }, [businessId]);

  return (
    <CategoryComponent
      show={show}
      className={`use-of-sold-category ${className || ""}`}
      leftBoxProps={{
        icon: <UseOfSoldIcon />,
        title: t("USE_OF_SOLD_PRODUCTS"),
        description: (
          <Trans i18nKey="COMP_USE_SOLD_DESC" components={{ b: <b /> }} />
        ),
        scopes: [{ scope: "Scope 3", filled: true }],
        isSystemBoundary: true,
        systemBoundary: systemBoundaryUseSold,
        setSystemBoundary: setSystemBoundaryUseSold,
        businessId: businessId,
        totalObjCategory: totalObjUseSold?.category_name,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: t("EXPENSES"),
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalObjUseSold,
                      totalObjUseSold?.total_expenses
                    ),
                  },
                ],
              },
              {
                subtitle: `${t("EMISSIONS")} (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjUseSold,
                      totalObjUseSold?.total_emissions
                    ),
                    scopes: ["S:3, C:11"],
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjUseSold?.updated_at
          ? formatDate(totalObjUseSold?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default UseOfSoldHeader;
